import { Component, inject } from '@angular/core';
import { FellerService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  FellerCreateDto,
  FellerDto,
  FellerExcelDownloadDto,
  FellerUpdateDto,
} from '../proxy/general/dtos/feller';
import { FELLER_CONFIG, FELLER_FIELDS } from './feller.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-feller',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, FellerService, ConfirmationService],
  templateUrl: './feller.html',
  styleUrl: './feller.scss',
})
export class Feller extends BaseHierarchicalCrudComponent<
  FellerDto,
  FellerCreateDto,
  FellerUpdateDto,
  FellerExcelDownloadDto
> {
  service = inject(FellerService);
  config = FELLER_CONFIG;
  fields = FELLER_FIELDS;

  protected prepareUpdateDto(data: any, selected: FellerDto): FellerUpdateDto {
    return {
      isHerbicideApplicator: data.isHerbicideApplicator,
      machineId: data.machineId,
      movilizationTypeId: data.movilizationTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Feller';
  }
}
